import axios from 'axios'
console.log(location.href)
// let p = location.href.split('/')[1]
// console.log(p)
const instance = axios.create({
  baseURL: '/',
  timeout: 5000,
  headers: {
    'X-Custom-Header': 'foobar',
    // 'language': p === 'en' ? 2 : 1 
  }
});

export default instance